export default "__VITE_ASSET__Do91wSs2__"